// extracted by mini-css-extract-plugin
export default {"container":"Movie_container__FAXRv","img":"Movie_img__bvU+l","title":"Movie_title__fq5kC","rating":"Movie_rating__g6iii","story":"Movie_story__6LCi+","genre":"Movie_genre__N0Fmy"};